import React from 'react';

const MenusContext = React.createContext();

export default MenusContext;
